export const coverFeature = {
  kicker: '本期封面深挖',
  title: '一条热搜的成本清单：谁在为你的注意力买单',
  summary:
    '我们把过去九十天里可核验的投放记录、代理报价与舆情处置时间线摆在同一张桌上，试图还原一条热搜从无到有的完整链路。它不属于任何一家公司的独家秘密，而是一套被反复使用的行业黑幕方法论。',
  meta: ['深度 42 分钟', '关联线索 37 条', '受访者 11 位'],
  image:
    'https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20illustration%20of%20a%20backstage%20corridor%20with%20warm%20amber%20stage%20lights%20and%20crimson%20curtains%2C%20long%20dramatic%20shadows%20and%20blurred%20silhouettes%2C%20cinematic%20depth%20of%20field%2C%20muted%20earthy%20tones%20with%20gold%20highlights%2C%20textured%20paper%20grain%2C%20magazine%20feature%20cover%20art%2C%20no%20text&width=1200&height=800&seq=bao-cover-01&orientation=landscape',
};

export const deepDiveList = [
  {
    id: 'd-01',
    tag: '资本运作',
    title: '对赌协议如何改写一部剧的开机名单',
    desc: '当业绩承诺写进合同，创作决定权就会悄悄转移。我们用三个项目的时间表还原了这个过程。',
    read: '12 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20abstract%20editorial%20texture%20with%20folded%20paper%20contract%20shapes%20and%20warm%20crimson%20ink%20stain%20on%20dark%20stone%20background%2C%20soft%20directional%20light%2C%20muted%20warm%20palette%2C%20magazine%20column%20thumbnail%20aesthetic%2C%20no%20text&width=240&height=240&seq=bao-thumb-01&orientation=squarish',
  },
  {
    id: 'd-02',
    tag: '幕后推手',
    title: '舆情处置的三段式手法与其固定客户',
    desc: '冷处理、转移焦点、反向叙事——三段式并非玄学，它有清晰的报价与执行节奏。',
    read: '9 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20abstract%20editorial%20texture%20of%20layered%20smoke%20curves%20and%20a%20small%20glowing%20amber%20lamp%20in%20darkness%2C%20soft%20grain%2C%20muted%20warm%20brown%20palette%2C%20quiet%20dramatic%20mood%2C%20magazine%20column%20thumbnail%20aesthetic%2C%20no%20text&width=240&height=240&seq=bao-thumb-02&orientation=squarish',
  },
  {
    id: 'd-03',
    tag: '饭圈操作',
    title: '控评组织的层级表：从打卡到结算',
    desc: '我们在两份不同的手册里找到了几乎相同的分工结构，说明它已经高度流程化。',
    read: '7 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20abstract%20editorial%20texture%20of%20stacked%20paper%20cards%20and%20thin%20gold%20grid%20lines%20on%20a%20dark%20warm%20background%2C%20soft%20shadow%2C%20muted%20earthy%20palette%2C%20orderly%20structured%20composition%2C%20magazine%20column%20thumbnail%20aesthetic%2C%20no%20text&width=240&height=240&seq=bao-thumb-03&orientation=squarish',
  },
];